import script from "./NewsPageRoof.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageRoof.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageRoof.vue?vue&type=style&index=0&id=9ea296e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ea296e0"]])

export default __exports__